import NonEditableBlock from './non-editable-block';
import dataURItoBlob from '@intercom/embercom-composer/lib/data-uri-to-blob';
import { and, bool, match, not, or } from '@ember/object/computed';
import { bind } from '@ember/runloop';
import Em from 'ember';
let blobUrlRegex = /^blob:/;
let dataUriRegex = /^data:/;
export default NonEditableBlock.extend({
  url: null,
  hasUploadError: false,
  hasFile: bool('file'),
  hasNoFile: not('hasFile'),
  hasUrl: bool('url'),
  hasNoUrl: not('hasUrl'),
  hasUploadErrorAndUrl: and('hasUploadError', 'hasUrl'),
  hasNoFileAndNoUrl: and('hasNoFile', 'hasNoUrl'),
  hasFileAndNoUrl: and('hasFile', 'hasNoUrl'),
  isUploadingOrHasUploadError: or('isUploading', 'hasUploadError'),
  shouldAttemptUpload: or('hasFileAndNoUrl', 'hasUploadErrorAndUrl', 'isDataUri'),
  urlContainsBlob: match('url', blobUrlRegex),
  isDataUri: match('url', dataUriRegex),
  isAnInvalidFile: or('hasNoFileAndNoUrl', 'urlContainsBlob'),
  hasSuccessfullyUploaded: not('isUploadingOrHasUploadError'),
  fetchFile: () => {},
  init() {
    if (this.get('id')) {
      this.set('uploadId', this.get('id'));
    }
    this._super();
    if (this.get('isAnInvalidFile')) {
      if (this.get('url') === null) {
        this.set('url', '');
      }
      this.set('hasUploadError', true);
    }
    if (this.get('shouldAttemptUpload')) {
      this.set('hasUploadError', false);
      this.preprocess().then(this._uploadFile.bind(this));
    }
  },
  preprocess() {
    return new Em.RSVP.Promise(function (resolve, reject) {
      let file = this.fetchFileWithCacheLookup();
      if (!file) {
        this.set('hasUploadError', true);
        reject();
        return;
      }
      resolve();
    }.bind(this));
  },
  fetchFileWithCacheLookup() {
    if (this.get('isDataUri')) {
      let file = dataURItoBlob(this.get('url'));
      this.set('file', file);
      return file;
    }
    let file = this.get('file');
    if (file) {
      return file;
    }
    let cachedUpload = this.get('uploadManager') && this.get('uploadManager').getFile(this.get('url'));
    if (cachedUpload) {
      this.set('file', cachedUpload);
    }
    return cachedUpload;
  },
  uploadStatusHtml: Em.computed('hasUploadError', 'isUploading', 'isRetry', function () {
    if (this.get('hasUploadError')) {
      if (this.get('fileTooLarge')) {
        return this.get('uploadTooLargeHtml');
      } else {
        return this.get('uploadErrorHtml');
      }
    }
    if (this.get('isUploading') && (this.get('isRetry') || this.get('isAttachment') || this.get('isVideoFile'))) {
      return this.get('uploadProgressHtml');
    }
    return '';
  }),
  uploadProgress(percentageComplete) {
    this.set('percentageComplete', percentageComplete);
  },
  retryUpload() {
    this.set('isRetry', true);
    this._uploadFile();
  },
  _turnOffUploadError: Em.observer({
    dependentKeys: ['url', 'urlContainsBlob'],
    fn() {
      if (this.get('url') && !this.get('urlContainsBlob')) {
        this.set('hasUploadError', false);
      }
    },
    sync: true
  }),
  uploadSuccess(policy) {
    this.setProperties({
      isUploading: false,
      hasUploadError: false,
      url: policy.public_url,
      uploadId: policy.id
    });
  },
  uploadFail(error) {
    this.setProperties({
      hasUploadError: true,
      isUploading: false,
      fileTooLarge: error.overSizeLimit,
      errorMessage: error.message
    });
  },
  _uploadFile() {
    let self = this;
    self.setProperties({
      hasUploadError: false,
      isUploading: true
    });
    this.get('uploadManager').addUpload(this.get('file'), bind(this, this.uploadProgress), this.get('uploadAttributes'), this.get('url'), this.get('isInline'), bind(this, this.get('fetchFile'))).then(policy => {
      this.uploadSuccess(policy);
    }).catch(error => {
      this.uploadFail(error);
    });
  }
});